import React from 'react'
import ProductSlider from '../Home/ProductSlider'

const ProductPage = () => {
  return (
    <>
        <ProductSlider/>
    </>
  )
}

export default ProductPage